var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"apparatusList"},_vm._l((_vm.list),function(value){return _c('div',{key:value.id,staticClass:"apparatus-item",on:{"click":function($event){return _vm.skipDetails(value.id)}}},[_c('img',{attrs:{"src":value.banner,"alt":""}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(value.name))])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b17c511","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Instrument/Components/apparatus.vue
// module id = null
// module chunks = 